import { gql } from "apollo-boost"

export const DELETE_MANY_DOCUMENTS_BY_URL = gql`
  mutation deleteManyDocumentsByUR($documentsToDelete: [String!]!) {
    DeleteManyDocuments(documentsToDeleteURL: $documentsToDelete)
  }
`